<template>
    <div class="d-flex flex-column">
        <ListTitleBar :titleCaption="listTitle"
                      :leftMenuItemListCaption="'追加'"
                      :leftMenuItemList="leftMenuItemList"
                      @onClickLeftMenuItem="onClickLeftMenuItem"
                      :btnCaption_1="'編集'"
                      :btnCaption_2="'削除'"
                      :btnActiveType_1="1"
                      :btnActiveType_2="3"
                      :rowCountArea="true"
                      :rowCount="getRowCount()"
                      :enableSearchText="true"
                      @onSearchBoxKeydown="onSearchBoxKeydown"
                      @onBtnClear="onBtnClear"
                      @onBtnClicked_1="onBtnUpd"
                      @onBtnClicked_2="onBtnDel"
                      :selectCount="getSelectCount()"
                      v-bind:disabled="isCheckMobileAndroid">
        </ListTitleBar>
        <ListCtrl ref="listCtrl"
                  :columns="columns"
                  :selectType="2"
                  :getCellTextFunc="getCellText"
                  :getCellHTMLFunc="getCellHTML"
                  :getRowClassFunc ="getRowClass"
                  @onClickCell="onClickCell"
                  style="min-height: 320px; max-height: 320px;">
        </ListCtrl>
    </div>
    <!-- Google Playストアのアプリケーションを追加、編集 -->
    <AppMgrPermissionAppEditModal ref="editModal"
                                  @onOK="onOKEditModal"
                                  :idName="idName"
                                  :addMode="addModeForPackageNameModal"
                                  :getURLFunction="getURLFunction"
                                  :getAppFunction="getAppFunction"
                                  :blackPackageList="blackPackageList"
                                  :whitePackageList="whitePackageList"
                                  :isMDMAppForUI="isMDMAppForUI"
                                  :mdmAppPackageName="mdmAppPackageName"
                                  :version="version"/>
    <!-- パッケージ名を入力して追加、編集 -->
    <AppMgrPermissionAppPackageNameModal ref="ref_appMgrPermissionAppPackageNameModal"
                                    @apply="applyAppMgrPermissionAppPackageNameModal"
                                    :subId="idName"
                                    :getSelectTopAppData="getSelectTopAppData"
                                    :addMode="addModeForPackageNameModal"
                                    :untrustedAppsPolicy="untrustedAppsPolicy"
                                    :mdmAppPackageName="mdmAppPackageName"
                                    :blackPackageList="blackPackageList"
                                    :whitePackageList="whitePackageList"/>
    <!-- Google Playストアのアプリケーションの詳細情報 -->
    <AppMgrApplicationDetailModal ref="detailModal" />
    <!-- 管理設定 -->
    <AppMgrManagedConfigurationModal ref="mgrModal"
                                     :list="managedPropertys"
                                     :listSetting="mgrConfigrations"
                                     :readonly="true" />
    <!-- アクセス権限閲覧画面 -->
    <AppMgrAccessAuthorityViewerModal ref="authModal"
                                      :list="applicationPermissions"
                                      :listSetting="permmsionGrants"
                                      :defaultPermission="defaultPermission"
                                      />
</template>

<script lang="ts">
    import { Options, Vue } from "vue-class-component";
    import { cloneDeep } from 'lodash';
    import { ListCtrl } from 'lib-vue-v2/components';
    import ListTitleBar from '@/components/ListTitleBar.vue';
    import { AndroidAppMgrDef } from '@/models/Mobile/AndroidAppDist/AndroidAppMgrDef';
    import { SearchColumnData, SearchColumnType } from '@/models/SearchColumnData';
    import { AndroidAppMgrApplicationSetting } from '@/models/Mobile/AndroidAppDist/AndroidAppMgrApplicationSetting'
    import { ApplicationPolicyConverter, ApplicationPolicyDef } from '@/models/Mobile/AndroidAppDist/ApplicationPolicyConverter'
    import AppMgrPermissionAppEditModal from '@/components/Mobile/AndroidAppDist/AppMgrPermissionAppEditModal.vue';
    import AppMgrPermissionAppPackageNameModal from '@/components/Mobile/AndroidAppDist/AppMgrPermissionAppPackageNameModal.vue';
    import AppMgrApplicationDetailModal from '@/components/Mobile/AndroidAppDist/AppMgrApplicationDetailModal.vue';
    import { LoadingUtil } from '@/util/LoadingUtil';
    import { MenuItemBase } from '@/models/MenuItemBase';
    import { MessageUtil } from '@/models/Message/MessageUtil';
    import { MessageText } from '@/models/Message/MessageText';
    import AppMgrManagedConfigurationModal from '@/components/Mobile/AndroidAppDist/AppMgrManagedConfigurationModal.vue';
    import AppMgrAccessAuthorityViewerModal from '@/components/Mobile/AndroidAppDist/AppMgrAccessAuthorityViewerModal.vue';
    import { AndroidAppDistDefinition } from "@/components/Mobile/AndroidAppDist/AndroidAppDistDefinition";
    import { BootstrapUtil } from 'lib-vue-v2/util';

    // for AndroidGooglePlayDialog
    import * as schema from '@/models/Mobile/Android/AndroidManagementV1Schema'

    @Options({
        props: {
            idName: { type: String, required: true },   // モーダル内のID関連の名前
            mode: { type: Number, required: true },   // 0:White/1:Black
            modelValue: { type: Array, required: true },  // Array<AndroidAppMgrApplicationSetting>, v-modelで指定
            getURLFunction: { type: Function },     // Google Play を iframe に埋め込むためのURL取得関数
            getAppFunction: { type: Function },     // アプリケーション詳細情報の取得関数
            getBlackPackageNameList: { type: Function, default: undefined },      // ブラックリストのパッケージ名を取得
            listTitle: { type: String, default: "" },   // リストのタイトル
            isCheckMobileAndroid: { type: Boolean, default: false }, // AndroidライセンスがONかどうか
            mdmAppPackageName: { type: String, default: "" }, // MDMアプリ情報
            enableAddMDMApp: { type: Boolean, default: false }, // MDMアプリの追加が可能かどうか
            version: { type: Number, default: 0 }, // 管理機のバージョン
            getUntrustedAppsPolicyFunction: { type: Function }      // 提供元不明のアプリケーションのインストール
        },
        components: {
            ListCtrl,
            ListTitleBar,
            AppMgrPermissionAppEditModal,
            AppMgrPermissionAppPackageNameModal,
            AppMgrApplicationDetailModal,
            AppMgrManagedConfigurationModal,
            AppMgrAccessAuthorityViewerModal,
        },
        watch: {
            modelValue: {
                handler: function () {
                    /* eslint @typescript-eslint/no-explicit-any: 0 */
                    const refObj: any = this.$refs;
                    refObj.listCtrl.updateList(this.modelValue.length);
                },
                deep: true,   // オブジェクトの監視
                immediate: false
            },
            enableAddMDMApp: {
                handler: function () {
                    this.updateLeftMenuItemList();
                },
                deep: true,   // オブジェクトの監視
                immediate: true
            }
        },
        emits: ['notifyUpdate','notifyMDMApp'],
    })

    export default class AppMgrPermissionAppList extends Vue {
        
        // 追加ボタンのメニュー
        private readonly ADD_SKYSEA_MDM_APP = 0;
        private readonly ADD_GOOGLE_PLAY_APP = 1;
        private readonly ADD_PACKAGE_NAME_APP = 2;
        private readonly leftMenuItemListWhite: Array<MenuItemBase> = new Array<MenuItemBase>(
            new MenuItemBase(this.ADD_SKYSEA_MDM_APP, "「SKYSEA MDM」アプリを追加"),
            new MenuItemBase(this.ADD_GOOGLE_PLAY_APP, "Google Playストアから選択して追加"),
            new MenuItemBase(this.ADD_PACKAGE_NAME_APP, "パッケージ名を指定して追加")
        );
        private readonly leftMenuItemListWhite_UNSKYSEA: Array<MenuItemBase> = new Array<MenuItemBase>(
            new MenuItemBase(this.ADD_GOOGLE_PLAY_APP, "Google Playストアから選択して追加"),
            new MenuItemBase(this.ADD_PACKAGE_NAME_APP, "パッケージ名を指定して追加")
        );
        private readonly leftMenuItemListBlack: Array<MenuItemBase> = new Array<MenuItemBase>(
            new MenuItemBase(this.ADD_SKYSEA_MDM_APP, "「SKYSEA MDM」アプリを追加"),
            new MenuItemBase(this.ADD_GOOGLE_PLAY_APP, "Google Playストアから選択して追加")
        );
        private readonly leftMenuItemListBlack_UNSKYSEA: Array<MenuItemBase> = new Array<MenuItemBase>(
            new MenuItemBase(this.ADD_GOOGLE_PLAY_APP, "Google Playストアから選択して追加")
        );
        private leftMenuItemList = this.leftMenuItemListWhite;

        // リスト関連
        private readonly columns: Array<SearchColumnData> =
            [
                { columnID: 7, dataType: SearchColumnType.icon | SearchColumnType.no_sort, text: "" },
                { columnID: 0, dataType: SearchColumnType.string | SearchColumnType.link, text: "アプリケーション名" },
                { columnID: 1, dataType: SearchColumnType.string, text: "パッケージ名" },
                { columnID: 4, dataType: SearchColumnType.string, text: "ステータス" },
                { columnID: 2, dataType: SearchColumnType.string, text: "インストール種別" },
                { columnID: 3, dataType: SearchColumnType.string, text: "自動アップデート種別" },
                { columnID: 5, dataType: SearchColumnType.string | SearchColumnType.link, text: "アクセス権限の許可設定" },
                { columnID: 6, dataType: SearchColumnType.string | SearchColumnType.link, text: "アプリケーション管理設定" },
            ];

        // props
        private getAppFunction!: any;
        private getBlackPackageNameList!: any;
        private listTitle!: string;
        private modelValue!:Array<AndroidAppMgrApplicationSetting>;
        private mode!:number;
        private idName!:string;
        private version!:number;
        private enableAddMDMApp!:boolean;

        // ポリシー⇔UIデータ
        private converter = new ApplicationPolicyConverter();

        // 定義値
        private def = new AndroidAppMgrDef();

        // 管理設定（詳細表示用）
        private mgrConfigrations: { [key: string]: any } = {}; // 設定データ(連想配列)
        private managedPropertys = new Array<schema.AMAPI_ManagedProperty>();  // 表示データ（名前とか説明とか）

        // アクセス権限情報（詳細表示用）（permmsionGrantsとapplicationPermissionsは長さが同じなこと）
        private permmsionGrants = new Array<schema.AMAPI_PermissionGrant>();    // 設定データ（ラジオの状態）
        private applicationPermissions = new Array<schema.AMAPI_ApplicationPermission>();   // 表示データ（名前とか説明とか）
        private defaultPermission: ApplicationPolicyDef.PERMISSION_GRANT_TYPE = ApplicationPolicyDef.PERMISSION_GRANT_TYPE.Prompt; // 既定の設定

        // 現在登録済みのアプリケーション（重複チェック用）
        private blackPackageList: Set<string> = new Set<string>();
        private whitePackageList: Set<string> = new Set<string>();
        
        // MDMアプリのパッケージ名
        private readonly mdmAppPackageName!: string;

        // 「SKYSEA MDMアプリを追加」ボタンからMDMアプリを追加かどうか
        private isMDMAppForUI: boolean = false;

       // 提供元不明のアプリケーションのインストール
        private untrustedAppsPolicy: boolean = false;

        // パッケージ名を入力して追加画面の追加、編集モード(true:追加  false:編集)
        private addModeForPackageNameModal: boolean = true;

        /**
         * @brief	mounted
         */
        public mounted(): void {
            this.updateLeftMenuItemList();
        }

        private updateLeftMenuItemList():void{
            if(this.mode === 0){
                if (this.enableAddMDMApp) this.leftMenuItemList = this.leftMenuItemListWhite;
                else this.leftMenuItemList = this.leftMenuItemListWhite_UNSKYSEA;
            }
            else{
                if (this.enableAddMDMApp) this.leftMenuItemList = this.leftMenuItemListBlack;
                else this.leftMenuItemList = this.leftMenuItemListBlack_UNSKYSEA;
            }
        }

        /**
         * リスト作成処理
         */
        private getCellText(columnId: number, index: number): string {

            if (this.modelValue.length <= index) {
                return "";
            }
            
            switch (columnId) {
                // アプリケーション名
                case 0:
                    // パッケージ名手動入力アプリは、通常テキストでアプリケーション名を表示する
                    if (AndroidAppDistDefinition.APP_SETTING_TYPE_FREE == this.modelValue[index].basicInfo.appSettingType) {
                        return this.modelValue[index].basicInfo.appName;
                    }
                    return "";

                // パッケージ名
                case 1:
                    return this.converter.GetPackageName(this.modelValue[index].policyJson);

                // インストール種別
                case 2:
                    // パッケージ名手動入力アプリは"-"固定
                    if (AndroidAppDistDefinition.APP_SETTING_TYPE_FREE == this.modelValue[index].basicInfo.appSettingType) {
                        return "-";
                    }
                    return this.converter.GetDistributionText(this.modelValue[index].policyJson);

                // 自動アップデート種別
                case 3:
                    // パッケージ名手動入力アプリは"-"固定
                    if (AndroidAppDistDefinition.APP_SETTING_TYPE_FREE == this.modelValue[index].basicInfo.appSettingType) {
                        return "-";
                    }
                    return this.converter.GetUpdateText(this.modelValue[index].policyJson);

                // 一時利用停止
                case 4:
                    return this.converter.GetDisabledText(this.modelValue[index].policyJson);

                // アクセス権限
                case 5:
                    {
                        // パッケージ名手動入力アプリは"-"固定
                        if (AndroidAppDistDefinition.APP_SETTING_TYPE_FREE == this.modelValue[index].basicInfo.appSettingType) {
                            return "-";
                        }
                        const str = this.converter.GetPermissionSettingListText(this.converter.ConvertStringToPermissionType(this.modelValue[index].policyJson.defaultPermissionPolicy), this.modelValue[index].policyJson.permissionGrants);
                        if (str.includes("個別設定あり")) {
                            // リンクなのでgetCellHTML()で記載
                            return "";
                        }
                        else {
                            return str;
                        }
                    }

                // 管理設定
                case 6:
                    {
                        // パッケージ名手動入力アプリは"-"固定
                        if (AndroidAppDistDefinition.APP_SETTING_TYPE_FREE == this.modelValue[index].basicInfo.appSettingType) {
                            return "-";
                        }
                        const str = this.converter.GetMgrConfigurationText(this.modelValue[index].policyJson.managedConfiguration);
                        if ("設定あり" == str) {
                            // リンクなのでgetCellHTML()で記載
                            return "";
                        }
                        else {
                            return str;
                        }
                    }
            }
            return "";
        }

        /**
         * リスト作成処理
         */
        private getCellHTML(columnId: number, index: number): string {

            if (this.modelValue.length <= index) {
                return "";
            }

            switch (columnId) {
                // アイコン
                case 7:
                    // パッケージ名手動入力アプリはアイコンなし
                    if (AndroidAppDistDefinition.APP_SETTING_TYPE_FREE == this.modelValue[index].basicInfo.appSettingType) {
                        return "<div style=\"padding: 8px 0px;\"><div style=\"height: 32px; width: 32px;\"></div></div>";
                    }
                    if (0 != this.modelValue[index].basicInfo.iconUrl.length) {
                        return "<div style=\"padding: 8px 0px;\"><img src=\"" + this.modelValue[index].basicInfo.iconUrl + "\" style=\"height: 32px; width: 32px; border-radius: 7px; border: 0.5px solid #E6EBF0\"></div>";
                    }
                    else {
                        return "<div style=\"padding: 8px 0px;\"><div style=\"height: 32px; width: 32px; border-radius: 7px; border: 0.5px solid #E6EBF0\"></div></div>";
                    }

                // アプリケーション名
                case 0:
                    // パッケージ名手動入力アプリは通常テキスト
                    if (AndroidAppDistDefinition.APP_SETTING_TYPE_FREE == this.modelValue[index].basicInfo.appSettingType) {
                        return "";
                    }
                    // リンク付き
                    return "<span class=\"scv-link-text\" style=\"cursor: pointer;\">" + this.modelValue[index].basicInfo.appName + "</span>";

                // アクセス権限
                case 5:
                    {
                        // パッケージ名手動入力アプリは通常テキスト
                        if (AndroidAppDistDefinition.APP_SETTING_TYPE_FREE == this.modelValue[index].basicInfo.appSettingType) {
                            return "";
                        }
                        const str = this.converter.GetPermissionSettingListText(this.converter.ConvertStringToPermissionType(this.modelValue[index].policyJson.defaultPermissionPolicy), this.modelValue[index].policyJson.permissionGrants);
                        if (str.includes("個別設定あり")) {
                            return "<span class=\"scv-link-text\" style=\"cursor: pointer;\">" + str + "</span>";
                        }
                        // 設定混在以外は通常テキスト
                        else {
                            return str;
                        }
                    }

                // 管理設定
                case 6:
                    {
                        // パッケージ名手動入力アプリは通常テキスト
                        if (AndroidAppDistDefinition.APP_SETTING_TYPE_FREE == this.modelValue[index].basicInfo.appSettingType) {
                            return "";
                        }
                        const str = this.converter.GetMgrConfigurationText(this.modelValue[index].policyJson.managedConfiguration);
                        if ("設定あり" == str) {
                            return "<span class=\"scv-link-text\" style=\"cursor: pointer;\">設定あり</span>";
                        }
                        return "";
                        // 設定なしは通常テキスト
                    }
            }
            return "";
        }

        /**
         * 行のクラス指定
         */
        private getRowClass(index: number): string {
            if (this.modelValue.length <= index) {
                return "";
            }
            if (false == this.converter.GetDisabled(this.modelValue[index].policyJson)) {
                // 利用可能
                return "";
            }
            else {
                // 利用停止中 : グレーアウト
                return " table-scv-disable-cell-color";
            }
        }

        /**
         * セルクリック時の処理
         */
        private onClickCell(columnId: number, index: number): void {
            if (this.modelValue.length <= index) {
                return ;
            }

            switch (columnId) {
                // アプリ名（詳細表示）
                case 0:
                    // パッケージ名手動入力アプリは通常テキスト
                    if (AndroidAppDistDefinition.APP_SETTING_TYPE_FREE == this.modelValue[index].basicInfo.appSettingType) {
                        return;
                    }
                    this.showDetail(this.modelValue[index]);
                    return;

                // アクセス権限
                case 5:
                    {
                        const str = this.converter.GetPermissionSettingListText(this.converter.ConvertStringToPermissionType(this.modelValue[index].policyJson.defaultPermissionPolicy), this.modelValue[index].policyJson.permissionGrants);
                        if (str.includes("個別設定あり")) {
                            // 個別設定ありのときだけだけリンク
                            this.showPermission(this.modelValue[index]);
                        }
                        return;
                    }

                // 管理設定
                case 6:
                    {
                        const str = this.converter.GetMgrConfigurationText(this.modelValue[index].policyJson.managedConfiguration);
                        if ("設定あり" == str) {
                            // 設定ありだけリンク
                            this.showManaged(this.modelValue[index]);
                        }
                        return;
                    }
            }
        }


        /**
         * 詳細表示
         */
        private showDetail(data: AndroidAppMgrApplicationSetting): void {
            // アプリ詳細画面を表示
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            refObj.detailModal.SetData(data.basicInfo);
            BootstrapUtil.showModal(refObj.detailModal.GetID());
        }

        /**
         * アクセス権限表示
         */
        private async showPermission(data: AndroidAppMgrApplicationSetting): Promise<void> {
            // 細かい詳細情報を取得
            LoadingUtil.Start();
            const res = await this.getAppFunction(data.basicInfo.packageName);
            LoadingUtil.Stop();

            if (res.status == 401) {
                // none(session timeout)
                return;
            }
            else if (res.status != 200) {
                MessageUtil.MessageBox(MessageText.dataGetErrorMessage, null, null, MessageUtil.MB_ICON_ERROR);
                return;
            }
            const application: schema.AMAPI_Application = Object.assign(new schema.AMAPI_Application(), res.data.appData);

            // アクセス権限
            if (undefined != application.permissions) {
                this.applicationPermissions = application.permissions;
            }
            else {
                this.applicationPermissions = new Array<schema.AMAPI_ApplicationPermission>();
            }

            if (undefined != data.policyJson.permissionGrants) {
                this.permmsionGrants = data.policyJson.permissionGrants;
            }
            else {
                this.permmsionGrants = new Array<schema.AMAPI_PermissionGrant>();
            }

            if (undefined != data.policyJson.defaultPermissionPolicy && null != data.policyJson.defaultPermissionPolicy) {
                this.defaultPermission = this.converter.ConvertStringToPermissionType(data.policyJson.defaultPermissionPolicy);
            }
            else {
                this.defaultPermission = ApplicationPolicyDef.PERMISSION_GRANT_TYPE.Prompt;
            }

            // propsで変数を渡しているが、タイムアウトで呼び出さないと画面に適用されない
            setTimeout(this.showPermissionDialog, 0);
        }

        /*
         * アクセス権限閲覧画面表示
         */
        private showPermissionDialog(): void {
            const refObj: any = this.$refs;
            BootstrapUtil.showModal(refObj.authModal.GetID());
        }

        /**
         * 管理設定表示
         */
        private async showManaged(data: AndroidAppMgrApplicationSetting): Promise<void> {
            // 細かい詳細情報を取得
            LoadingUtil.Start();
            const res = await this.getAppFunction(data.basicInfo.packageName);
            LoadingUtil.Stop();

            if (res.status == 401) {
                // none(session timeout)
                return;
            }
            else if (res.status != 200) {
                MessageUtil.MessageBox(MessageText.dataGetErrorMessage, null, null, MessageUtil.MB_ICON_ERROR);
                return;
            }
            const application: schema.AMAPI_Application = Object.assign(new schema.AMAPI_Application(), res.data.appData);

            // 管理設定
            if (undefined != application.managedProperties) {
                this.managedPropertys = application.managedProperties;
            }
            else {
                this.managedPropertys = new Array<schema.AMAPI_ManagedProperty>();
            }
            if (undefined != data.policyJson.managedConfiguration || null != data.policyJson.managedConfiguration) {
                this.mgrConfigrations = data.policyJson.managedConfiguration;
            }
            else {
                this.mgrConfigrations = {};
            }

            // propsでmanagedPropertys等を渡しているが、タイムアウトで呼び出さないと画面に適用されない
            setTimeout(this.showManagedDialog, 0);
        }

        /*
         * 管理設定閲覧画面表示
         */
        private showManagedDialog(): void {
            const refObj: any = this.$refs;
            BootstrapUtil.showModal(refObj.mgrModal.GetID());
            
        }

        /*
         * 選択状態の数を返します
         */
        private getSelectCount(): number {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;

            // マウント前はundefinedの可能性があるのでundefinedチェックが必要
            if (undefined == refObj.listCtrl) {
                return 0;
            }
            return refObj.listCtrl.getSelectListIndex().length;
        }

        /*
         * 選択状態の数を返します
         */
        private getRowCount(): number {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;

            // マウント前はundefinedの可能性があるのでundefinedチェックが必要
            if (undefined == refObj.listCtrl) {
                return 0;
            }
            return refObj.listCtrl.getDisplayListIndex().length;
        }

        /*
         * 文字検索開始（Enter押下）
         */
        private onSearchBoxKeydown(searchText: string): void {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            refObj.listCtrl.search(searchText);
        }

        /*
         * 文字検索終了（解除押下）
         */
        private onBtnClear(): void {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            refObj.listCtrl.search("");
        }

        /**
         * @brief	追加ボタン
         */
        private async onClickLeftMenuItem(selectId: number): Promise<void> {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;

            switch (selectId) {
                case this.ADD_SKYSEA_MDM_APP:
                case this.ADD_GOOGLE_PLAY_APP:
                case this.ADD_PACKAGE_NAME_APP:
                    if (this.def.APPLICATION_LIST_MAX_LENGTH <= this.modelValue.length) {
                        MessageUtil.MessageBox(
                            "これ以上登録することはできません。<br />" + this.listTitle + "の登録上限は"+ this.def.APPLICATION_LIST_MAX_LENGTH + "件です。"
                            , null
                            , null
                            , MessageUtil.MB_ICON_WARNING
                        );
                        return;
                    }

                    // 重複チェック用の変数を準備
                    this.blackPackageList = new Set<string>();
                    if (undefined != this.getBlackPackageNameList) {
                        this.blackPackageList = this.getBlackPackageNameList();
                    }
                    this.whitePackageList = new Set<string>();
                    this.modelValue.forEach(x => {
                        this.whitePackageList.add(x.basicInfo.packageName.toLowerCase())
                    });
                    
                    this.addModeForPackageNameModal = true;
                    // SKYSEA MDMアプリを追加
                    if (selectId === this.ADD_SKYSEA_MDM_APP) {
                        this.isMDMAppForUI = true;
                        // SKYSEAMDMアプリをセット
                        if (!await refObj.editModal.SetMDMApp()) {
                            return;
                        }
                        this.$nextTick(() => {      // propsの更新が間に合わないので待つ
                            BootstrapUtil.showModal(refObj.editModal.GetID());
                        });
                    }
                    // Google Playストアアプリを追加
                    else if (selectId === this.ADD_GOOGLE_PLAY_APP) {
                        this.isMDMAppForUI = false;
                        this.$nextTick(() => {      // propsの更新が間に合わないので待つ
                            BootstrapUtil.showModal(refObj.editModal.GetID());
                        });
                    }
                    // パッケージ名を入力して追加
                    else {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        this.untrustedAppsPolicy = this.getUntrustedAppsPolicyFunction();
                        this.$nextTick(() => {
                            BootstrapUtil.showModal("AppMgrPermissionAppPackageNameModal" + this.idName);
                        });
                    }
                    break;
                default:
                    break;
            }
        }

        /**
         * @brief	編集ボタン
         */
        private async onBtnUpd(): Promise<void> {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            const indexs = refObj.listCtrl.getSelectListIndex();
            if (1 != indexs.length) {
                return;
            }
            
            // 重複チェック用の変数を準備（編集のときは重複チェックはいらないので不要だが、念のため作成しておく）
            this.blackPackageList = new Set<string>();
            if (undefined != this.getBlackPackageNameList) {
                this.blackPackageList = this.getBlackPackageNameList();
            }
            this.whitePackageList = new Set<string>();
            this.modelValue.forEach(x => {
                this.whitePackageList.add(x.basicInfo.packageName.toLowerCase())
            });

            this.addModeForPackageNameModal = false;

            this.isMDMAppForUI = false;
            const topItem = this.getSelectTopAppData();
            if(topItem?.basicInfo.packageName === this.mdmAppPackageName){
                this.isMDMAppForUI = true;
            }

            // Google Playストアアプリを編集
            if (AndroidAppDistDefinition.APP_SETTING_TYPE_GOOGLE_PLAY == this.modelValue[indexs[0]].basicInfo.appSettingType) {
                // 編集データのセット
                if (!await refObj.editModal.SetEditSeting(cloneDeep(this.modelValue[indexs[0]]))) {
                    return;
                }
                // propsの更新が間に合わないので待つ
                this.$nextTick(() => {
                    BootstrapUtil.showModal(refObj.editModal.GetID());
                });
            }
            // パッケージ名を手動入力アプリを編集
            else {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.untrustedAppsPolicy = this.getUntrustedAppsPolicyFunction();
                this.$nextTick(() => {
                    BootstrapUtil.showModal("AppMgrPermissionAppPackageNameModal" + this.idName);
                });
            }
        }

        private getSelectTopAppData(): AndroidAppMgrApplicationSetting | undefined {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            const indexs = refObj.listCtrl.getSelectListIndex();
            if (1 != indexs.length) {
                return undefined;
            }

            // 編集データのセット
            const selectTopAppData = cloneDeep(this.modelValue[indexs[0]]);
            return selectTopAppData;
        }

        /**
         * @brief	追加/編集でOKが押下
         */
        private onOKEditModal(data: AndroidAppMgrApplicationSetting, addMode: boolean): void {

            this.$emit("notifyUpdate");

            if (addMode) {
                // 追加するだけ
                this.modelValue.push(data);

                // MDMアプリが追加された
                if (this.mdmAppPackageName == this.converter.GetPackageName(data.policyJson)) {
                    this.$emit("notifyMDMApp", true);
                }
                return;
            }

            // 編集データを更新する
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            const indexs = refObj.listCtrl.getSelectListIndex();
            if (1 != indexs.length) {
                return;
            }

            this.modelValue[indexs[0]] = data;
        }
        
        /**
         * @brief	パッケージ名を指定の追加/編集でOKが押下
         */
        private applyAppMgrPermissionAppPackageNameModal(applicationName: string, packageName: string, applicationDisabled: boolean, addMode: boolean): void {

            this.$emit("notifyUpdate");

            if (addMode) {
                var applicationSetting = new AndroidAppMgrApplicationSetting();
                applicationSetting.basicInfo.appName = applicationName;
                applicationSetting.basicInfo.packageName = packageName;
                applicationSetting.basicInfo.updateTimeUtc = new Date();
                applicationSetting.basicInfo.appSettingType = AndroidAppDistDefinition.APP_SETTING_TYPE_FREE;

                applicationSetting.policyJson.appNameforScv = applicationName;
                applicationSetting.policyJson.packageName = packageName;

                this.converter.SetDistributionType(applicationSetting.policyJson, ApplicationPolicyDef.DISTRIBUTION_TYPE.WhiteManual);  // パッケージ名を指定して追加の場合、インストールタイプを指定する必要がないが、SKYSEA側でインストールタイプを設定していないと禁止に倒しているので、手動配布のインストールタイプを設定しておく
                this.converter.SetDisabled(applicationSetting.policyJson, applicationDisabled);

                // 追加するだけ
                this.modelValue.push(applicationSetting);
                return;
            }

            // 編集データを更新する
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            const indexs = refObj.listCtrl.getSelectListIndex();
            if (1 != indexs.length) {
                return;
            }

            var editapplicationSetting = this.modelValue[indexs[0]];
            editapplicationSetting.basicInfo.appName = applicationName;
            editapplicationSetting.basicInfo.packageName = packageName;
            editapplicationSetting.basicInfo.updateTimeUtc = new Date();
            editapplicationSetting.basicInfo.appSettingType = AndroidAppDistDefinition.APP_SETTING_TYPE_FREE;

            editapplicationSetting.policyJson.appNameforScv = applicationName;
            editapplicationSetting.policyJson.packageName = packageName;
            
            this.converter.SetDistributionType(editapplicationSetting.policyJson, ApplicationPolicyDef.DISTRIBUTION_TYPE.WhiteManual);  // パッケージ名を指定して追加の場合、インストールタイプを指定する必要がないが、SKYSEA側でインストールタイプを設定していないと禁止に倒しているので、手動配布のインストールタイプを設定しておく
            this.converter.SetDisabled(editapplicationSetting.policyJson, applicationDisabled);
            this.modelValue[indexs[0]] = editapplicationSetting;
        }

        /**
         * @brief	削除ボタン
         */
        private onBtnDel(): void {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            const selectedIndex = refObj.listCtrl.getSelectListIndex();

            // MDMアプリが削除された
            const dmdAppIncluded = selectedIndex.some((index: number) => this.mdmAppPackageName === this.modelValue[index].policyJson.packageName);
            if (dmdAppIncluded) {
                this.$emit("notifyMDMApp", false);
            }
            
            for (let i = selectedIndex.length - 1 ; 0 <= i; i--) {
               this.modelValue.splice(selectedIndex[i], 1);
            }

            this.$emit("notifyUpdate");
        }
    }
</script>

<style>
    /* アプリケーション管理部分のCSSはオンプレ版と共通を使用する */
    @import "../../../assets/css/MobileAndroidCommon.css";
</style>